import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronFillRight = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M10.659 33.309V6.69c0-2.393 2.896-3.59 4.585-1.9l13.309 13.308a2.673 2.673 0 0 1 0 3.791L15.244 35.21c-1.688 1.688-4.585.492-4.585-1.901Z" })
});
export default SvgChevronFillRight;
